export default function BackgroundGradient() {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 0,
      }}
    >
      {/* Blob 1 — gold */}
      <div
        style={{
          position: "absolute",
          top: "20%",
          left: "15%",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(212, 168, 67, 0.12)",
          filter: "blur(120px)",
          animation: "blobFloat1 18s ease-in-out infinite",
        }}
      />
      {/* Blob 2 — navy */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "10%",
          width: 350,
          height: 350,
          borderRadius: "50%",
          background: "rgba(26, 26, 62, 0.15)",
          filter: "blur(100px)",
          animation: "blobFloat2 22s ease-in-out infinite",
        }}
      />
      {/* Blob 3 — dark red */}
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          left: "40%",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(100, 20, 20, 0.08)",
          filter: "blur(100px)",
          animation: "blobFloat3 15s ease-in-out infinite",
        }}
      />
    </div>
  );
}
